import _trimStart from 'lodash/trimStart';
import _split from 'lodash/split';
import _replace from 'lodash/replace';
import _includes from 'lodash/includes';
import _forEach from 'lodash/forEach';

import { FAKE_TOP_LEVEL_DOMAINS, MODULE_SEPARATOR, TESTING_DOMAINS_PREFIX, TRAIFFIC_SHAPPING_PREFIX } from './constants';

/**
 * Get the normalized server name
 * @returns {string}
 */
export var getNormalizedHostname = function getNormalizedHostname() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;

  // Strip www. to ensure that ship.freightos.com and www.ship.freightos.com share the same strings
  var normalizedHostname = _trimStart(hostname, 'www.');

  // Remove all the testing prefix.
  _forEach(TESTING_DOMAINS_PREFIX, function (prefix) {
    normalizedHostname = _replace(normalizedHostname, prefix, '');
  });

  // This ensures that our fake .local, .cn domain names
  _forEach(FAKE_TOP_LEVEL_DOMAINS, function (TLD) {
    normalizedHostname = _replace(normalizedHostname, TLD, '.com');
  });

  // Remove traffic shaping prefix
  normalizedHostname = _trimStart(normalizedHostname, TRAIFFIC_SHAPPING_PREFIX);

  return normalizedHostname;
};
/**
 * Map locale from freightos form to react intl form
 * @param locale The user locale
 */
export var mapLocale = function mapLocale(locale) {
  return _split(locale, '_')[0];
};

/**
 * Check if the string id has module name or not
 * @param id The string id
 */
export var hasModule = function hasModule(id) {
  return _includes(id, MODULE_SEPARATOR);
};

/**
 * Check ig the translator has value for this id
 * @param messages all translation ids and values
 * @param id the string id
 * @returns {boolean}
 */
export var hasString = function hasString(messages, id) {
  return !!messages[id];
};

/**
 * Add sub module to string id
 * @param id the string id
 * @param module the string module
 * @returns {string}
 */
export var addIdSubModule = function addIdSubModule(id, module) {
  return '' + module + MODULE_SEPARATOR + id;
};

/**
 * Add module name to the id if not exist
 * @param module The module name
 * @param id The string id
 */
export var addModuleIfNotExist = function addModuleIfNotExist(id, module) {
  return hasModule(id) ? id : '' + module + MODULE_SEPARATOR + id;
};

/**
 * Throw required error if called
 */
export var required = function required() {
  throw new Error('Missing argument');
};